import React from "react";
import { StoryNode } from "../../StoryBook/StoryData";
import { PropertyEditorExpression, PropertyEditorExpressionInterface } from "../PropertyEditorExpression";
import { ExpressionConfiguration } from "../../../rule-engine-core/Expressions/ExpressionConfiguration";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";

import { getFilledDataDefinition } from "../../../rule-engine-core/Common/Data/DataTestData";
import { ExpressionViewEmptyBehavior } from "../../../Expressions/ExpressionView";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class SectionData implements PropertyEditorExpressionInterface {
    editObject: object = {
        expression: new ExpressionConfiguration(),
    };
    propertyName: string = "expression";
    resultType: IDataDefinition = new StringDataDefinition();

    inputDataFunction() {
        return getFilledDataDefinition();
    }
}

class SectionData2 implements PropertyEditorExpressionInterface {
    editObject: { expression: ExpressionConfiguration } & IDesignValidationProvider = {
        expression: new ExpressionConfiguration(),
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "expression"), new ValidationIssue("issue2", "expression")];
        },
    };
    propertyName: string = "expression";
    resultType: IDataDefinition = new StringDataDefinition();

    inputDataFunction() {
        return getFilledDataDefinition();
    }
}

export const PropertyEditorExpressionStories = [
    new StoryNode(
        () => {
            const params = new SectionData();
            return (
                <PropertyEditorExpression
                    {...params}
                    inputDataFunction={params.inputDataFunction}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Expression",
        "Default",
    ),

    new StoryNode(
        () => {
            const params = new SectionData();
            return (
                <PropertyEditorExpression
                    {...params}
                    inputDataFunction={params.inputDataFunction}
                    emptyBehavior={ExpressionViewEmptyBehavior.EXPRESSION}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Expression",
        "Expression First",
    ),

    new StoryNode(
        () => {
            const params = new SectionData();
            return (
                <PropertyEditorExpression
                    {...params}
                    inputDataFunction={params.inputDataFunction}
                    emptyBehavior={ExpressionViewEmptyBehavior.VARIABLE}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Expression",
        "Variable First",
    ),

    new StoryNode(
        () => {
            const params = new SectionData();
            return (
                <PropertyEditorExpression
                    {...params}
                    inputDataFunction={params.inputDataFunction}
                    emptyBehavior={ExpressionViewEmptyBehavior.VALUE}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Expression",
        "Value First",
    ),

    new StoryNode(
        () => {
            const params = new SectionData();
            return (
                <PropertyEditorExpression
                    {...params}
                    error={"Error Text"}
                    inputDataFunction={params.inputDataFunction}
                    emptyBehavior={ExpressionViewEmptyBehavior.EXPRESSION}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Expression",
        "Expression First - Error",
    ),

    new StoryNode(
        () => {
            const params = new SectionData();
            return (
                <PropertyEditorExpression
                    {...params}
                    error={"Error Text"}
                    inputDataFunction={params.inputDataFunction}
                    emptyBehavior={ExpressionViewEmptyBehavior.VARIABLE}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Expression",
        "Variable First - Error",
    ),

    new StoryNode(
        () => {
            const params = new SectionData();
            return (
                <PropertyEditorExpression
                    {...params}
                    inputDataFunction={params.inputDataFunction}
                    emptyBehavior={ExpressionViewEmptyBehavior.VALUE}
                    error={"Error Text"}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Expression",
        "Value First - Error",
    ),
    new StoryNode(
        () => {
            const params = new SectionData2();
            return (
                <PropertyEditorExpression
                    {...params}
                    inputDataFunction={params.inputDataFunction}
                    emptyBehavior={ExpressionViewEmptyBehavior.EXPRESSION}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Expression",
        "Expression First - Validation Provider",
    ),

    new StoryNode(
        () => {
            const params = new SectionData2();
            return (
                <PropertyEditorExpression
                    {...params}
                    inputDataFunction={params.inputDataFunction}
                    emptyBehavior={ExpressionViewEmptyBehavior.VARIABLE}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Expression",
        "Variable First - Validation Provider",
    ),

    new StoryNode(
        () => {
            const params = new SectionData2();
            return (
                <PropertyEditorExpression
                    {...params}
                    inputDataFunction={params.inputDataFunction}
                    emptyBehavior={ExpressionViewEmptyBehavior.VALUE}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Expression",
        "Value First - Validation Provider",
    ),
];
